<ng-container *ngIf="this.sourceAuh.accessDenied && configurationCotisations ;else showLib">
    <div class="col-12 ng-star-inserted">
        <p-messages [(value)]="enableErrorMessageCourtier" [enableService]="false" [closable]="false"></p-messages>
    </div>
</ng-container>
<ng-template #showLib>
    <lib-paiement-en-ligne [configuration]="configurationPaiement" (onEmitAmountToPayEvent)="handleEmitAmountToPayEvent($event)" ></lib-paiement-en-ligne>
    <lib-liste-cotisation [configuration]="configuration"></lib-liste-cotisation>
</ng-template>